import axios from 'axios';
import { API_BASE_URL } from './config';

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

export const fetchRegulations = async ({ lang, page = 1 }) => {
  const response = await apiClient.get('/regulations/', { 
    params: { lang, page } 
  });
  return response.data; // Return full response including results, next, etc.
};

export const fetchRegulationsByCategory = async ({ activeCategory, lang }) => {
  const response = await apiClient.get('/regulations/', {
    params: { 
      regulation_type: activeCategory?.id || activeCategory,
      lang 
    },
  });
  return response.data.results || response.data;
};

export const fetchCategories = async (lang) => {
  const response = await apiClient.get('/regulations/categories/', {
    params: { lang }
  });
  return response.data;
};

// Fetch all regulations across all pages
export const fetchAllRegulations = async ({ lang }) => {
  let allResults = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const response = await apiClient.get('/regulations/', { 
      params: { lang, page } 
    });
    const data = response.data;
    allResults = [...allResults, ...data.results];
    hasNext = !!data.next;
    page += 1;
  }

  return allResults;
};